export default __webpack_public_path__ + "static/media/330_business05-es-web.a590120b.png";